/*eslint-disable */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import styled, { css } from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import cpfValidate from '@vr/devkit/validators/cpfValidate';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import Button from '../../../elements/Button';
import Checkbox from '../../../elements/Checkbox';
import TextField, { DateField, MaskField } from '../../../elements/TextField';
import getErrorMsg from '../../../helpers/errorMessages';
import messages from '../../../helpers/api/messages';
import AddressForm from '../AddressForm';
import Select from '../../Select';
import { users as UsersApi } from '../../../helpers/api';
import { ToastCtx } from '~/providers/ToastProvider';
import { ReCaptcha } from '~/components';
import { setSuccessKey } from '~/store/modules/recaptcha/actions';
import axiosInstance from '~/config/axios';
import infoWarnPasswordCircle from '../../../assets/warning-circle.svg';
import infoWarnPasswordCircleCaixa from '../../../assets/warning-circle-caixa.svg';
import getEnv from '~/helpers/getEnv';
import axios from '../../../config/axios';
export const JVCEF = 'JVCEF';

const Actions = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    max-width: 333px;
    &:first-of-type {
      margin-bottom: 10px;
    }
  }
`;

const OptIns = styled.div`
  margin-top: 45px;
`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  margin-top: 25px;
  padding: 0 16px;
`;

const InfoPassword = styled.div`
  display: flex;
  margin-right: -15px;
  margin-left: -15px;
  margin-top: 25px;
  padding: 0 16px;
  color: #fff;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

const ImgInfoPassword = styled.img`
  width: 30px;
  height: 30px;
`;

const Link = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondary};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Container = styled.div`
  margin-top: 20px;
  position: relative;

  ${({ isLoading }) =>
    isLoading &&
    css`
      & > form {
        opacity: 0.5;
        pointer-events: none;
      }
    `}

  button {
    max-width: 333px !important;
  }
`;

moment.locale('pt-br');

const formatDate = date => {
  const splitted = date.split('/');
  return new Date(`${splitted[1]}/${splitted[0]}/${splitted[2]}`);
};

const UserDataForm = ({
  user: userData,
  onSave = () => {},
  setIsLoading,
  isLoading,
  recaptcha = false,
}) => {
  const dispatch = useDispatch();
  const [termsChecked, setTermsChecked] = useState(false);
  const [newsletterChecked, setNewsletterChecked] = useState(
    !!userData?.newsletter,
  );
  const [resetRecaptcha, setResetRecaptcha] = useState(false);
  const toast = React.useContext(ToastCtx);
  const history = useHistory();
  const { siteKey, successKey } = useSelector(state => state.recaptcha);
  const issuer = useSelector(state => state?.issuer);
  const [disabledField, setDisabledField] = useState(true);
  const {
    handleSubmit,
    errors,
    formState,
    getValues,
    ...formControl
  } = useForm({
    mode: 'onChange',
    defaultValues: userData
      ? {
          ...userData,
          cpf: userData.cpf.replace(
            /([0-9]{3})([0-9]{3})([0-9]{3})([0-9]{2})/,
            '$1.$2.$3-$4',
          ),
          cellphone: (
            userData.cellphone.prefix + userData.cellphone.number
          ).replace(/([0-9]{2})([0-9]{5})([0-9]{4})/, '($1) $2-$3'),
          address: userData.address && {
            ...userData.address,
            zipcode: userData.address.zipcode.replace(
              /([0-9]{5})([0-9]{3})/,
              '$1-$2',
            ),
          },
          birthdate: formatDate(userData?.birthdate),
        }
      : {},
  });

  function setAxiosHeader(key) {
    axiosInstance.defaults.headers.common = {
      'response-captcha': key,
    };
  }

  function handleForgtPassword(event) {
    event.preventDefault();
    toast.close();
    history.push('/esqueci-minha-senha');
  }

  const onSubmit = React.useCallback(
    async ({ address, ...data }) => {
      if (recaptcha) {
        setAxiosHeader(successKey);
      }

      setIsLoading(true);
      try {
        const obj = {
          ...data,
          birthdate: moment(data.birthdate).format('DD/MM/yyyy'),
          cellphone: {
            prefix: data.cellphone.match(/\((.*)\)/)[1],
            number: data.cellphone
              .match(/\(\d\d\)\s([\d]{5}-[\d]{4})/)[1]
              .replace(/\D/g, ''),
          },
          cpf: data.cpf.replace(/\D/g, ''),
        };

        if (address?.zipcode) {
          obj.address = {
            ...address,
            zipcode: address.zipcode.replace('-', ''),
          };
        }

        if (userData) {
          await UsersApi.edit(obj, {
            cpf: userData.cpf,
          });
          toast.dispatch(
            'Dados atualizados',
            'success',
            'Seus dados foram atualizados e salvos com sucesso.',
          );
          onSave();
        } else {
          await UsersApi.register(obj);
          toast.dispatch(
            'Falta pouco, estamos quase lá!',
            'success',
            <>
              Um link de confirmação foi enviado para o e-mail: {data.email}.
              Caso não tenha recebido, verifique a sua <b>caixa de spam</b> ou a{' '}
              <b>lixeira</b>.
            </>,
          );
          onSave();
        }
      } catch (e) {
        if (e.response?.data?.messages?.find(item => item.code === '-3')) {
          history.push('/login');
          toast.dispatch(
            messages(
              e.response?.data || e,
              'register',
              <>
                O usuário informado já está cadastrado, caso não se recorde,{' '}
                <Link onClick={handleForgtPassword} href="#">
                  clique aqui
                </Link>
                , para recuperar seu acesso.
              </>,
            ),
            'error',
          );
        } else {
          toast.dispatch(messages(e.response?.data || e, 'register'), 'error');
        }

        setResetRecaptcha(true);
      }
      setIsLoading(false);
    },
    // eslint-disable-next-line
    [onSave, toast, history, recaptcha, successKey],
  );

  useEffect(() => {
    if (userData) {
      formControl.trigger();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (successKey === '') {
      setResetRecaptcha(true);
    }
  }, [successKey]);

  function handleSuccessKey(key) {
    setResetRecaptcha(false);
    dispatch(setSuccessKey(key));
  }

  const validarCpf = async cpf => {
    if (!cpfValidate(cpf)) {
      setDisabledField(true);
      return 'CPF inválido';
    }
    setDisabledField(false);
    const context = getEnv('usuario');
    const cpfNumerico = String(cpf).replace(/\D/g, '');

    if (issuer.name === 'VRPAT') {
      try {
        const response = await axios.get(
          `${context}:443/users/${cpfNumerico}/permite-cadastro`,
        );

        const { result } = response.data;
        const isValid = result === true;
        setDisabledField(!isValid);

        if (!isValid) {
          toast.dispatch({
            title: 'O Portal do Trabalhador foi descontinuado',
            type: 'error',
            description:
              'Use o SuperApp VR e acesse todas as funções do portal e muito mais! \nLá você consulta saldos, extratos, pode fazer compras, pagar contas e outros.',
            custom: true,
          });
          return 'CPF inválido';
        }
        return true;
      } catch (error) {
        toast.dispatch({
          title: 'O Portal do Trabalhador foi descontinuado',
          type: 'error',
          description:
            'Use o SuperApp VR e acesse todas as funções do portal e muito mais! \nLá você consulta saldos, extratos, pode fazer compras, pagar contas e outros.',
          custom: true,
        });
        setDisabledField(true);
        return 'Erro ao validar CPF';
      }
    }
  };
  return (
    <Container isLoading={isLoading}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <TextField
              ariaLabel="nome completo"
              fullWidth
              label="Seu nome completo *"
              name="name"
              rules={{
                required: true,
                validate: val => {
                  return !!val.match(/[a-zA-Z]{2,}\s[a-zA-Z]{2,}/g);
                },
              }}
              formControl={formControl}
              error={!!errors.name}
              caption={getErrorMsg(errors, 'name')}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <MaskField
              ariaLabel="cpf"
              fullWidth
              label="Seu CPF *"
              name="cpf"
              mask="999.999.999-99"
              type="tel"
              executeActionOnBlur={() => formControl.trigger('cpf')}
              rules={{
                required: 'O CPF é obrigatório',
                minLength: { value: 14, message: 'CPF inválido' },
                validate: validarCpf,
              }}
              formControl={formControl}
              error={!!errors.cpf}
              caption={getErrorMsg(errors, 'cpf')}
              disabled={userData?.cpf}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Select
              disabled={disabledField}
              arialLabel="sexo"
              label="Sexo *"
              name="gender"
              formControl={formControl}
              rules={{
                required: true,
              }}
              value={formControl.watch('gender') || ''}
              options={[
                {
                  label: '',
                  value: '',
                  disabled: true,
                },
                {
                  label: 'Masculino',
                  value: 'Masculino',
                },
                {
                  label: 'Feminino',
                  value: 'Feminino',
                },
              ]}
              error={!!errors.gender}
              caption={getErrorMsg(errors, 'gender')}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <MaskField
              ariaLabel="número de celular"
              fullWidth
              label="Número do seu celular *"
              name="cellphone"
              type="tel"
              mask="(99) 99999-9999"
              rules={{
                required: true,
                validate: val => {
                  return !!val?.match(/\([1-9]{2}\)\s[2-9][0-9]{4}-[0-9]{4}/g);
                },
              }}
              formControl={formControl}
              disabled={disabledField}
              error={!!errors.cellphone}
              caption={getErrorMsg(errors, 'cellphone')}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <DateField
              disabled={disabledField}
              ariaLabel="data de nascimento"
              fullWidth
              label="Data de nascimento *"
              name="birthdate"
              type="date"
              maxDate={moment().subtract(14, 'years')}
              minDate={moment().subtract(100, 'years')}
              rules={{
                required: true,
                validate: val => {
                  const date = moment(val, 'DD/MM/YYYY', true);
                  return (
                    date.isValid() &&
                    moment().diff(date, 'years') > 13 &&
                    moment().diff(date, 'years') <= 100
                  );
                },
              }}
              formControl={formControl}
              error={!!errors.birthdate}
              caption={getErrorMsg(errors, 'birthdate')}
            />
          </Grid>
          {!userData && (
            <>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  disabled={disabledField}
                  ariaLabel="email"
                  fullWidth
                  label="Seu e-mail *"
                  name="email"
                  type="email"
                  rules={{
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    },
                  }}
                  formControl={formControl}
                  error={!!errors.email}
                  caption={getErrorMsg(errors, 'email')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  disabled={disabledField}
                  ariaLabel="confirme seu email"
                  fullWidth
                  name="confirmEmail"
                  label="Confirme seu e-mail *"
                  type="email"
                  rules={{
                    required: true,
                    validate: val => val === getValues('email'),
                  }}
                  formControl={formControl}
                  error={!!errors.confirmEmail}
                  caption={getErrorMsg(errors, 'confirmEmail')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  disabled={disabledField}
                  ariaLabel="senha"
                  fullWidth
                  label="Sua senha *"
                  name="password"
                  rules={{
                    required: true,
                    validate: val => {
                      return !!val.match(
                        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&)%(@!';:#}{,.^?~=+\-_\/*\-+.\|])[0-9a-zA-Z$*&)%(@!';:#}{,.^?~=+\-_\/*\-+.\|]{8,}$/,
                      );
                    },
                  }}
                  type="password"
                  formControl={formControl}
                  error={!!errors.password}
                  caption={getErrorMsg(errors, 'password')}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6}>
                <TextField
                  disabled={disabledField}
                  ariaLabel="confirme sua senha"
                  fullWidth
                  name="confirmPassword"
                  label="Confirme sua senha *"
                  type="password"
                  rules={{
                    required: true,
                    validate: val => val === getValues('password'),
                  }}
                  formControl={formControl}
                  error={!!errors.confirmPassword}
                  caption={getErrorMsg(errors, 'confirmPassword')}
                />
              </Grid>
            </>
          )}
        </Grid>

        <InfoPassword>
          {issuer?.name === JVCEF ? (
            <ImgInfoPassword src={infoWarnPasswordCircleCaixa} />
          ) : (
            <ImgInfoPassword src={infoWarnPasswordCircle} />
          )}
          Sua senha precisa ter no mínimo 8 caracteres e conter ao menos um
          número, um símbolo, uma letra minúscula e uma letra maiúscula.
        </InfoPassword>

        <AddressForm
          disabled={disabledField}
          address={userData?.address}
          formControl={{
            errors,
            formState,
            getValues,
            ...formControl,
          }}
        />

        <OptIns>
          {!userData && (
            <Row>
              <Checkbox
                disabled={disabledField}
                ariaLabel="termos de uso"
                noLabelCheck
                label={
                  <>
                    Li e aceito os{' '}
                    <Link href={issuer?.terms?.use?.value} target="_blank">
                      {issuer?.terms?.use?.name}
                    </Link>{' '}
                    e{' '}
                    <Link
                      href={issuer?.terms?.privacity?.value}
                      target="_blank"
                    >
                      {issuer?.terms?.privacity?.name}
                    </Link>
                  </>
                }
                inputRef={formControl.register({
                  required: true,
                })}
                name="terms"
                onChange={e => {
                  setTermsChecked(e.target.checked);
                }}
                checked={termsChecked}
              />
            </Row>
          )}
          <Row>
            <Checkbox
              disabled={disabledField}
              label={`Aceito receber comunicações da ${issuer?.company} pelos canais de comunicações disponibilizados`}
              inputRef={formControl.register}
              name="newsletter"
              checked={newsletterChecked}
              onChange={e => {
                setNewsletterChecked(e.target.checked);
              }}
            />
          </Row>
        </OptIns>
        {siteKey && recaptcha && (
          <Actions>
            <div>
              <ReCaptcha
                data-testid="captcha"
                sitekey={siteKey}
                onChange={handleSuccessKey}
                resetRecaptcha={resetRecaptcha}
              />
            </div>
          </Actions>
        )}
        <Actions>
          <Button
            ariaLabel={userData ? 'atualizar dados' : 'fazer cadastro'}
            fullWidth
            label={userData ? 'Atualizar dados' : 'Fazer cadastro'}
            type="submit"
            variant="contained"
            disabled={
              (!userData && !formState.isValid) ||
              (recaptcha ? !successKey : false)
            }
          />
        </Actions>
        <div className="back">
          {userData ? (
            <Button
              ariaLabel="cancelar"
              fullWidth
              label="Cancelar"
              variant="transparent"
              onClick={() => history.push('/home')}
            />
          ) : (
            <Button
              ariaLabel="já sou cadastrado"
              fullWidth
              label="Já sou cadastrado"
              variant="transparent"
              onClick={() => history.push('/login')}
            />
          )}
        </div>
      </form>
    </Container>
  );
};

UserDataForm.propTypes = {
  onSave: PropTypes.func,
  user: PropTypes.object,
  setIsLoading: PropTypes.func,
  isLoading: PropTypes.bool,
  recaptcha: PropTypes.bool,
};

export default UserDataForm;
